import type { ReservationStatus } from "@/types/reservation";

export const STATUS_LABELS: Record<ReservationStatus, string> = {
  pending: "承認待ち",
  approved: "利用予定",
  rejected: "却下",
  cancelled: "キャンセル",
  in_use: "利用中",
  overdue: "返却遅延",
  returned: "返却完了",
  inspection: "確認中",
};

export const STATUS_COLORS: Record<ReservationStatus, { bg: string; fg: string; border: string }> = {
  pending: { bg: "#fef9c3", fg: "#854d0e", border: "#eab308" },
  approved: { bg: "#dbeafe", fg: "#1e40af", border: "#3b82f6" },
  in_use: { bg: "#dcfce7", fg: "#166534", border: "#22c55e" },
  returned: { bg: "#f3e8ff", fg: "#6b21a8", border: "#a855f7" },
  overdue: { bg: "#fee2e2", fg: "#991b1b", border: "#ef4444" },
  rejected: { bg: "#f1f5f9", fg: "#475569", border: "#94a3b8" },
  cancelled: { bg: "#f1f5f9", fg: "#475569", border: "#94a3b8" },
  inspection: { bg: "#ffedd5", fg: "#9a3412", border: "#f97316" },
};

export function statusLabel(status: ReservationStatus): string {
  return STATUS_LABELS[status];
}

export const RETURNABLE_STATUSES: ReservationStatus[] = ["approved", "in_use", "overdue"];

export const CANCELLABLE_STATUSES: ReservationStatus[] = ["pending", "approved"];
